import api from 'api';

export const loadReviews = api('GET /api/gallery-concepts/:conceptId/reviews');

export const createReview = api(
  'POST /api/gallery-concepts/:conceptId/reviews'
);

export const updateReview = api('PUT /api/gallery-concepts/:conceptId/reviews');

export const removeReview = api(
  'DELETE /api/gallery-concepts/:conceptId/reviews/:id'
);
